import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { InputLabeledContainer, Select, TextInput } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

const TruckDetails = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    truckTypes
  } = props
  return (
    <>
      <h4 className="bold">{t('document:truckDetails')}</h4>
      <div className="d-flex mb-24">
        <InputLabeledContainer
          name="truckType"
          label={t('document:truckType')}
          className="mr-8 w-50"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          renderInput={(rest) => (
            <Select
              items={truckTypes.map((type) => ({ label: type.name, value: type.id }))}
              className="form-select"
              {...rest}
            />
          )}
        />
        <InputLabeledContainer
          name="plateNumber"
          label={t('document:truckPlates')}
          className="mr-8 w-50"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          renderInput={(rest) => <TextInput placeholder="XXXXXXX" maxLength={INPUT_CHARACTER_LIMITS.PLATES} {...rest} />}
        />
        <InputLabeledContainer
          name="trailerNumber"
          label={t('document:trailerPlates')}
          className="mr-8 w-50"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          renderInput={(rest) => (
            <TextInput
              placeholder="XXXXXXX"
              maxLength={INPUT_CHARACTER_LIMITS.PLATES}
              {...rest} />
          )}
        />
      </div>
    </>
  )
}

export default React.memo(TruckDetails)
